/**
 * Do not edit directly.
 * Generated via Design Token Pipeline
 */
import React from 'react';
import { convertIconPropsToSvgProps } from '../../utils';
export const IconSoOutboundServiceCall = React.forwardRef((iconProps, ref) => {
    const props = convertIconPropsToSvgProps(iconProps);
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", "aria-label": "icon", ref: ref, ...props },
        React.createElement("g", null,
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m9.666 3.001 10.248.49c.63.03 1.115.564 1.085 1.194l-.488 10.267a1.14 1.14 0 1 1-2.278-.109l.357-7.512L3.907 20.703a1.139 1.139 0 0 1-1.61-.077 1.144 1.144 0 0 1 .076-1.613L17.057 5.64l-7.5-.358A1.141 1.141 0 0 1 9.666 3Z" })),
        React.createElement("defs", null,
            React.createElement("clipPath", null,
                React.createElement("path", { d: "M0 0h24v24H0z" })))));
});
IconSoOutboundServiceCall.displayName = 'IconSoOutboundServiceCall';
export default IconSoOutboundServiceCall;
